import React from 'react';
import { Play, Info } from 'lucide-react';
import { useDetail } from '../context/DetailContext';

const FreeMovieHero = ({ movie }) => {
  const { openFree } = useDetail();
  return (
    <section data-testid="free-movie-hero" className="relative h-[88vh] min-h-[560px] w-full overflow-hidden">
      <img src={movie.thumbnail} alt="" className="absolute inset-0 w-full h-full object-cover blur-3xl scale-125 opacity-60" />
      <img src={movie.thumbnail} alt={movie.title} className="absolute right-16 top-1/2 -translate-y-1/2 h-[55%] rounded-2xl shadow-2xl border border-white/10 hidden lg:block" />
      <div className="absolute inset-0 hero-left-fade" />
      <div className="absolute inset-x-0 bottom-0 h-2/3 hero-bottom-fade" />
      <div className="relative z-10 h-full flex items-end pb-24 pl-10 pr-10 md:pl-16">
        <div className="max-w-2xl">
          <div className="flex items-center gap-3 mb-4">
            <span className="px-2 py-1 rounded-md text-[10px] font-bold tracking-widest bg-emerald-500 text-black">FREE MOVIE</span>
            {movie.year && <span className="text-white/70 text-sm">{movie.year}</span>}
            <span className="text-white/70 text-sm">{Math.round(movie.duration_sec / 60)} min</span>
          </div>
          <h1 data-testid="free-movie-hero-title" className="font-display text-5xl md:text-7xl text-white drop-shadow-[0_4px_24px_rgba(0,0,0,0.8)] leading-[0.95]">{movie.title}</h1>
          <p className="mt-5 text-white/85 text-base md:text-lg leading-relaxed line-clamp-3 max-w-xl">{movie.description}</p>
          <div className="mt-7 flex items-center gap-3 flex-wrap">
            <button data-testid="free-movie-hero-play-btn" onClick={() => openFree(movie, true)} className="tv-focusable inline-flex items-center gap-2 px-7 py-3 rounded-lg bg-white text-black font-semibold hover:bg-white/90">
              <Play size={20} className="fill-black" /> Play
            </button>
            <button data-testid="free-movie-hero-info-btn" onClick={() => openFree(movie)} className="tv-focusable inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-white/15 text-white font-semibold hover:bg-white/25 backdrop-blur">
              <Info size={18} /> More info
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FreeMovieHero;
